document.addEventListener("click", (e) => {
  const popupOpener = e.target.closest(".selection_popup_button");
  const commerceShopLink = e.target.closest(".cc-ResultPanel-module-wrap_1jQaz");
  const amazonButton = e.target.closest(".js-emit-event--amazon")
  // prevent double click on mobile!
  if (e.detail === 0) return;

  if (amazonButton) {
    Shopify.analytics.publish("commerce_connector:amazon_click");
  }

  if (commerceShopLink) {
    Shopify.analytics.publish("commerce_connector:shop_click");
  }

  if (popupOpener) {
    Shopify.analytics.publish("commerce_connector:popup_opener_click");
  }
});
